export const color = {
  black: "#000",
  greenBlue: "#7BA8BA"
};
